var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVprint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.01547 14C4.42313 14 3.62696 14 3.06012 13.6601C2.68965 13.4379 2.39119 13.1203 2.19856 12.7431C1.90384 12.166 1.98307 11.403 2.14151 9.87687C2.27377 8.60292 2.33991 7.96591 2.66513 7.49811C2.87865 7.19097 3.16744 6.93923 3.50598 6.76515C4.02161 6.5 4.68623 6.5 6.01547 6.5H12.9845C14.3138 6.5 14.9784 6.5 15.494 6.76515C15.8326 6.93923 16.1214 7.19097 16.3349 7.49811C16.6601 7.96591 16.7263 8.60292 16.8585 9.87687C17.017 11.403 17.0962 12.166 16.8014 12.7431C16.6088 13.1203 16.3104 13.4379 15.9399 13.6601C15.373 14 14.5769 14 12.9845 14",
    stroke: "#172B4D",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 6.5V5C13.25 3.58579 13.25 2.87868 12.8106 2.43934C12.3713 2 11.6642 2 10.25 2H8.75C7.33578 2 6.62868 2 6.18934 2.43934C5.75 2.87868 5.75 3.58579 5.75 5V6.5",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9915 12.5H8.00848C7.49452 12.5 7.23753 12.5 7.01887 12.5817C6.72733 12.6905 6.4777 12.902 6.30965 13.1824C6.18361 13.3928 6.12129 13.6633 5.99663 14.2043C5.80185 15.0496 5.70446 15.4722 5.77069 15.8112C5.85901 16.263 6.13428 16.6455 6.51689 16.848C6.80385 17 7.20539 17 8.00848 17H10.9915C11.7946 17 12.1962 17 12.4831 16.848C12.8657 16.6455 13.141 16.263 13.2293 15.8112C13.2955 15.4722 13.1982 15.0496 13.0034 14.2043C12.8788 13.6633 12.8164 13.3928 12.6904 13.1824C12.5223 12.902 12.2727 12.6905 11.9812 12.5817C11.7625 12.5 11.5055 12.5 10.9915 12.5Z",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0005 9.5H14.0065",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVprint);
export default __webpack_public_path__ + "static/media/vprint.ec430e0fbb736070774c10bf3409a695.svg";
export { ForwardRef as ReactComponent };